import { findFlagUrlByCountryName } from 'country-flags-svg'
import mainRoutes from './routes';

const sortCountryList = (countries, routes = mainRoutes) => {
  let focusedCountry = [];
  let nonFocusedCountry = [];

  countries?.map((country) => {
    const countryObj = {
      title: country?.name,
      path: `/${country?.full_slug}`,
      flag:  findFlagUrlByCountryName(country?.name || "")
    };

    if (country?.content?.is_active === 'active') {
      focusedCountry = [...focusedCountry, countryObj];
    } else {
      nonFocusedCountry = [...nonFocusedCountry, countryObj];
    }
    return null;
  });

  return [focusedCountry, nonFocusedCountry];
};

export default sortCountryList;
